import {
  ComparisonTable,
  Row,
} from "design-system/components/blocks/comparison-table/comparison-table";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { ComparisonTableEntry } from "frontend/contentful/schema/blocks";
import { useContentful } from "frontend/hooks/use-contentful";

export const ContentfulComparisonTable =
  createContentfulComponent<ComparisonTableEntry>(({ entry }) => {
    const { getEntries } = useContentful();
    const rowGroups = getEntries(entry.fields.rowGroups);

    const tableRows: Array<Row> = [];

    rowGroups.forEach((group) => {
      if (group.fields.title) {
        tableRows.push({
          isFullRow: true,
          rowHeader: group.fields.title,
        });
      }

      const rowEntries = getEntries(group.fields.rows);

      rowEntries.forEach((row) => {
        tableRows.push({
          rowHeader: row.fields.title,
          data: row.fields.data,
        });
      });
    });

    return (
      <ComparisonTable
        showOnlyYesCells={entry.fields.showOnlyYesCells}
        align={entry.fields.alignment}
        theme={entry.fields.theme}
        columnHeaders={entry.fields.columnHeaders || []}
        rows={tableRows}
      />
    );
  });
